(() => {
  const invitation = document.querySelector('[data-pm-offer-invitation]');
  if (invitation) {
    document.documentElement.classList.add('pm-offer-gated');
    const syncOffer = () => {
      if (document.documentElement.classList.contains('pm-offer-gated') && document.body.classList.contains('__seguno-disable-scroll')) invitation.hidden = false;
    };
    document.addEventListener('seguno::popup::impression',()=>{invitation.hidden=false;});
    document.addEventListener('seguno::popup::close',()=>{
      document.documentElement.classList.add('pm-offer-gated');
      invitation.hidden = true;
      document.querySelector('.pm-journey-help summary,.pm-order-tile,#MainContent a')?.focus({preventScroll:true});
    });
    invitation.querySelector('button').addEventListener('click',()=>{
      document.documentElement.classList.remove('pm-offer-gated');
      invitation.hidden = true;
      const popup = document.querySelector('seguno-popup');
      if (popup) { popup.setAttribute('tabindex','-1'); popup.focus(); }
    });
    new MutationObserver(syncOffer).observe(document.body,{attributes:true,attributeFilter:['class']});
    syncOffer();
  }
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const animated = new WeakSet();
  const reveal = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal.unobserve(entry.target);
      if (!reduced.matches) entry.target.animate([{opacity:.35,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:360,easing:'cubic-bezier(.2,.75,.25,1)'});
    }
  }, {threshold:.08});
  const enhance = () => {
    document.querySelectorAll('.pm-toolbar-categories a').forEach(a => {
      if (new URL(a.href).pathname === location.pathname) a.setAttribute('aria-current','page');
      else a.removeAttribute('aria-current');
    });
    document.querySelectorAll('#product-grid > li:not([hidden]),.pm-order-tile').forEach(card => {
      if (animated.has(card)) return;
      animated.add(card);
      reveal.observe(card);
    });
    document.querySelectorAll('.pm-filter-dialog').forEach(dialog => {
      if (dialog.dataset.experienceReady) return;
      dialog.dataset.experienceReady = 'true';
      dialog.addEventListener('close', () => {
        if (matchMedia('(max-width:989px)').matches) dialog.closest('pm-simple-filters')?.querySelector('[data-filter-open]')?.focus({preventScroll:true});
      });
    });
  };
  reduced.addEventListener('change',()=>{if(reduced.matches)document.getAnimations().forEach(a=>{try{a.finish();}catch{a.cancel();}});});
  enhance();
  document.addEventListener('purefect:collection-updated',enhance);
  document.addEventListener('shopify:section:load',enhance);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-order-entry] video').forEach(v=>v.pause());});
})();
